import { Box, Text } from '@common-fe/common-fe';
import styled, { css } from 'styled-components';

export const Wrapper = styled(Box)`
  z-index: 1;
  overflow: hidden;

  box-sizing: border-box;
`;

export const TitleWrapper = styled(Box)`
  height: 35px;
  .icon {
    font-size: 32px;
    color: ${({ theme }) => theme.colors.iconAccent};
  }
`;
interface Props {
  disabledGradient?: boolean;
}
export const GradientBox = styled(Box)<Props>`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    right: 0;
    ${({ theme, disabledGradient }) => {
      if (disabledGradient) {
        return css``;
      }
      return css`
        // background: linear-gradient(180deg, ${theme.colors.module} 50%, transparent 100%);
      `;
    }}
  }
`;

export const IconWrapper = styled.button`
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: transparent;
    border: none;
  }
`;

export const Item = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 15px;
`;
export const ItemText = styled.p`
  ${({ theme }) => theme.fonts.text16Medium};
  margin-bottom: 15px;
`;

export const CoveredBlock = styled.div`
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  height: 44px;
  bottom: 0;

  /* background: ${({ theme }) => theme.colors.fade1}; */
  background: linear-gradient(
    0deg,
    #f7f9fa 8.21%,
    rgba(247, 249, 250, 0.91) 40.81%,
    rgba(247, 249, 250, 0) 100%
  );
`;

export const DisabledNotificationButton = styled(Text)`
  min-height: 32px;
  height: 32px;
  padding: 0 ${({ theme }) => theme.spacings.m};
  ${({ theme }) => theme.fonts.text14Regular};
  color: ${({ theme }) => theme.colors.textDisabled};
  display: flex;
  align-items: center;
  justify-content: center;
`;
